"use client";

import { Button, Input, Radio, Typography } from "@/components/ui";
import { useConversion, UseConversionProps } from "./use-conversion";

export type ConversionProps = UseConversionProps;

export const Conversion = (props: ConversionProps) => {
  const { styles, form, onSubmit } = useConversion(props);

  return (
    <div className={styles.base()}>
      <form
        noValidate
        onSubmit={form.handleSubmit(onSubmit)}
        className={styles.form()}
      >
        <Input
          {...form.register("name")}
          label="Nome"
          placeholder="Nome"
          hideLabel
          autoComplete="name"
          className="col-span-full"
          error={form.formState.errors.name}
        />
        <Input
          {...form.register("email")}
          type="email"
          label="E-mail"
          placeholder="E-mail"
          hideLabel
          autoComplete="email"
          className="col-span-full sm:col-span-1"
          error={form.formState.errors.email}
        />
        <Input
          {...form.register("phone")}
          type="tel"
          label="Telefone"
          placeholder="Telefone"
          hideLabel
          mask="phone"
          autoComplete="tel"
          className="col-span-full sm:col-span-1"
          error={form.formState.errors.phone}
        />
        <div className="col-span-full">
          <Typography className="mb-4">
            Qual sua preferência de contato?
          </Typography>
          <div className="flex flex-wrap gap-4">
            <Radio
              {...form.register("contact_preference")}
              id={`contact-preference-whatsapp`}
              label="WhatsApp"
              value="whatsapp"
              error={form.formState.errors.contact_preference}
            />
            <Radio
              {...form.register("contact_preference")}
              id={`contact-preference-phone`}
              label="Ligação"
              value="phone"
              error={form.formState.errors.contact_preference}
            />
          </div>
        </div>
        <Button
          appearance="solid"
          type="submit"
          className="col-span-full"
          fullWidth
          isLoading={form.formState.isSubmitting}
        >
          Enviar
        </Button>
      </form>
    </div>
  );
};
